import type { MallStats } from "@mall-mart/shared";

function baseUrl(serverWsUrl: string): string {
  return serverWsUrl.replace(/^ws(s)?:/, "http$1:");
}

// Latest mall stats, shared app-wide: the atrium displays update via
// main.ts's refresh loop, and shop units read the snapshot lazily when their
// interiors build. null until the first successful fetch.
let latest: MallStats | null = null;

export function getMallStats(): MallStats | null {
  return latest;
}

/** Fetch the mall-wide stats; failures return the previous snapshot so the
 *  displays keep showing the last known data instead of blanking. */
export async function refreshMallStats(serverWsUrl: string): Promise<MallStats | null> {
  try {
    const res: Response = await fetch(`${baseUrl(serverWsUrl)}/api/mall-stats`);
    if (!res.ok) {
      throw new Error(`GET /api/mall-stats failed: ${res.status}`);
    }
    const data: { stats: MallStats } = await res.json();
    latest = data.stats;
  } catch (err: unknown) {
    console.error("[Mall Mart] Mall stats refresh failed:", err);
  }
  return latest;
}
